"use strict";
import React from "react";
import { Group } from "react-art";
import DragPoint from "./drag_point";
import { getDisplayName } from "./utils";
export default (AnnotationComponent) => {
  const DragPoints = ({
    dragPoints,
    hovered = false,
    hoveredDragPointIndex
  }) => {
    let dragPointViews = null;
    if (hovered) {
      dragPointViews = dragPoints.map((dragPoint, i) => {
        return /* @__PURE__ */ React.createElement(
          DragPoint,
          {
            position: dragPoint,
            hovered: hoveredDragPointIndex === i,
            key: i
          }
        );
      });
    }
    return /* @__PURE__ */ React.createElement(Group, null, dragPointViews);
  };
  DragPoints.displayName = `DragPointsFor(${getDisplayName(AnnotationComponent)})`;
  return DragPoints;
};
